<template>
  <div class="head-box" :style="{ background: transparent ? '' : '#3177FF' }">
    <div class="head">
      <div class="logo">
        <span>智慧招采云平台</span>
      </div>
      <div class="menu">
        <div @click="goIndex" :class="activeIndex === 'Index' ? 'active' : ''">首页</div>
        <div @click="goProcureInfo" :class="activeIndex === 'ProcurementInfo' || activeIndex == 'ProcurementInfoDetail'
          ? 'active'
          : ''
          ">
          招采信息
        </div>
        <div @click="goProcureNotices" :class="activeIndex === 'ProcurementNotice' ||
          activeIndex === 'ProcurementNoticeDetail'
          ? 'active'
          : ''
          ">
          采购公告
        </div>
        <div @click="goBidNotices" :class="activeIndex === 'BidWinningNotice' || activeIndex == 'BidWinningNoticeDetail'
          ? 'active'
          : ''
          ">
          中标公告
        </div>
        <div @click="goNotice" :class="activeIndex === 'NotificationAnnouncement' ||
          activeIndex == 'NotificationAnnouncementDetail'
          ? 'active'
          : ''
          ">
          通知公告
        </div>
        <div @click="goIndustryConsultation" :class="activeIndex === 'IndustryConsultation' ||
          activeIndex == 'IndustryConsultationDetail'
          ? 'active'
          : ''
          ">
          行业资讯
        </div>
        <div @click="goPolicy" :class="activeIndex === 'PolicyRegulation' || activeIndex == 'PolicyRegulationDetail'
          ? 'active'
          : ''
          ">
          政策法规
        </div>
        <el-input placeholder="请输入项目编号、项目名称、公告标题等" v-model="title" class="input-with-select"
          @keyup.enter.native="getAllList">
          <i slot="prefix" class="el-input__icon el-icon-search" @click="getAllList"></i>
        </el-input>
        <el-button v-if="!haveToken" class="register_r" @click="register">注册</el-button>
        <el-button v-if="!haveToken" type="primary" class="login_l" @click="login_page">登录</el-button>
        <el-dropdown v-if="haveToken" class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <i class="iconfont icon-touxiang ct-g-avatar" />
            <span class="ct-g-name" :title="userName">{{ userName }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="enterBackSys">
              <i class="iconfont icon-mima_1" />
              <span style="display: inline-block">进入后台</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <i class="iconfont icon-tuichu" />
              <span style="display: inline-block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <supplier-login v-if="isShow" @closeDialog="closeDialog" :isSignUp="isSignUp"></supplier-login>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getToken, getUsername, setAuth, setUserType } from "@/utils/auth";
import { getInfo, isAuthExpert, isAuthPur, isAuthSupplier } from "@/api/supplierLogin";
import SupplierLogin from "@/views/supplierLogin.vue";
import { eventBus } from "@/utils/EventBus";
export default {
  components: {
    SupplierLogin,
  },
  data() {
    return {
      activeIndex: this.$route.name,
      scroll: false,
      haveToken: getToken(),
      userName: getUsername(),
      isShow: false,
      title: "",
      isSignUp: false,
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        this.activeIndex = newVal.name;
      },
    },
  },
  mounted() {
    console.log(this.$store, " this.$store.state.");
    console.log(this.$route.name);
    //窗口滚动至顶部
    window.addEventListener("scroll", (e) => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.scroll = scrollTop > 0;
    });
  },
  created() {
    eventBus.$on("show-login", (data) => {
      this.isSignUp = data;
      this.isShow = true;
    });
    this.getInfoName();
  },
  computed: {
    transparent() {
      return !this.scroll;
    },
  },
  methods: {
    getInfoName() {
      if (getToken()) {
        getInfo().then((resp) => {
          this.userName = resp.user.nickName;
        });
      }
    },
    getAllList() {
      if (this.$route.name === 'ProcurementInfo') {
        // 如果已经在PageA，直接触发查询逻辑
        this.$router.app.$emit('ProcurementInfoSearch', { title: this.title });
      } else {
        this.$router.push({ path: "/ProcurementInfo", query: { title: this.title } });
      }
    },
    login_page() {
      this.isSignUp = false;
      this.isShow = true;
      // location.href = process.env.VUE_APP_BASE_API_LOGIN
      // window.open(process.env.VUE_APP_BASE_API_LOGIN, "_blank");
    },
    register() {
      // location.href = process.env.VUE_APP_BASE_API_REGISTER
      window.open(process.env.VUE_APP_BASE_API_REGISTER, "_blank");
    },
    goIndex() {
      if (this.activeIndex !== "Index") {
        this.activeIndex = "Index";
        this.$router.push("index");
      }
    },
    goPolicy() {
      if (this.activeIndex !== "PolicyRegulation") {
        this.activeIndex = "PolicyRegulation";
        this.$router.push("PolicyRegulation");
      }
    },

    goProcureInfo() {
      if (this.activeIndex !== "ProcurementInfo") {
        this.activeIndex = "ProcurementInfo";
        this.$router.push("ProcurementInfo");
      }
    },
    goNotice() {
      if (this.activeIndex !== "NotificationAnnouncement") {
        this.activeIndex = "NotificationAnnouncement";
        this.$router.push("NotificationAnnouncement");
      }
    },
    goProcureNotices() {
      if (this.activeIndex !== "ProcurementNotice") {
        this.activeIndex = "ProcurementNotice";
        this.$router.push("ProcurementNotice");
      }
    },
    goBidNotices() {
      if (this.activeIndex !== "BidWinningNotice") {
        this.activeIndex = "BidWinningNotice";
        this.$router.push("BidWinningNotice");
      }
    },
    logout() {
      this.$confirm("确定退出？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("logout").then(() => {
            location.href = process.env.NODE_ENV === "production" ? "/index" : "/portal/index";
          });
        })
        .catch(() => { });
    },
    enterBackSys() {
      getInfo().then((res) => {
        console.log(res.user);
        const userType = res.user.userType;
        setUserType(userType);
        if (userType == "1") {
          window.open(process.env.VUE_APP_BASE + "/index", "_blank");
        } else if (userType == "2") {
          isAuthPur().then((resp) => {
            setAuth(resp.data ? 1 : 0);
            if (resp.data) {
              window.open(process.env.VUE_APP_BASE + "/index", "_blank");
            } else {
              const URL = process.env.VUE_APP_BASE + "/supplierCer?type=" + userType;
              window.open(URL, "_blank");
            }
          });
        } else if (userType == "3") {
          isAuthSupplier().then((resp) => {
            setAuth(resp.data ? 1 : 0);
            if (resp.data) {
              window.open(process.env.VUE_APP_BASE + "/index", "_blank");
            } else {
              const URL = process.env.VUE_APP_BASE + "/supplierCer?type=" + userType;
              window.open(URL, "_blank");
            }
          });
        } else if (userType == "4") {
          isAuthExpert().then((resp) => {
            setAuth(resp.data ? 1 : 0);
            if (resp.data) {
              window.open(process.env.VUE_APP_BASE + "/index", "_blank");
            } else {
              const URL = process.env.VUE_APP_BASE + "/expert?type=" + userType;
              window.open(URL, "_blank");
            }
          });
        }
      });
      // window.open(process.env.VUE_APP_BASE, "_blank");
    },
    closeDialog() {
      this.isShow = false;
    },
    goIndustryConsultation() {
      if (this.activeIndex !== "IndustryConsultation") {
        this.activeIndex = "IndustryConsultation";
        this.$router.push("IndustryConsultation");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-with-select {
  width: 300px;

  ::v-deep .el-input__inner {
    background: rgba(255, 255, 255, 0);
    height: 32px;
    color: white;
    border-radius: 4px;
    border: 1px solid #FFFFFF;
  }

  .el-icon-search {
    color: white;
  }

  ::placeholder {
    color: rgba(255, 255, 255, 0.46);
    /* 这里可以设置你想要的颜色 */
  }
}

// @media screen and (min-width: 1366px) {
//   .head-box {
//     .head {
//       min-width: 1320px;
//       max-width: 1320px;
//     }
//   }
// }

@media screen and (min-width: 1600px) {
  .head-box {
    .head {
      min-width: 1200px;
      max-width: 1200px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .head-box {
    .head {
      min-width: 1170px;
      max-width: 1170px;
    }
  }
}

.head-box {
  position: fixed;
  height: 60px;
  top: 0;
  border-bottom: rgba(0, 11, 23, 0.04) 1px solid;
  width: 100%;
  min-width: 1200px;
  display: flex;
  justify-content: center;
  z-index: 200;
  // padding: 17px 0;
}

.scorll-top {
  background: #fff;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 1300px;

  .logo {
    display: flex;
    flex-flow: row nowrap;

    /*align-self: center;*/
    /*align-items: center;*/
    img {
      height: 35px;
    }

    span {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .menu {
    display: flex;
    align-items: center;

    div {
      margin-left: 10px;
      margin-right: 12px;
      height: 50px;
      font-size: 14px;
      cursor: pointer;
      line-height: 50px;
      font-weight: 400;
      color: #ffffff;
      position: relative;

      &::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 2px;
        background: "";
        border-radius: 6px 6px 6px 6px;
        position: absolute;
        left: 0;
        bottom: 8px;
      }

      .ct-g-avatar {
        vertical-align: middle;
        margin-right: 5px;
      }

      .ct-g-name {
        display: inline-block;
        max-width: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
    }

    .active {
      color: #fff;
      // border-bottom: 3px solid #fff;

      &::after {
        background: #ffffff;
      }
    }

    // .activeNo {
    //   color: #8f939b;
    // }
    .register_r {
      /*width: 65px;*/

      height: 32px;
      line-height: 32px;
      background: transparent;
      display: flex;
      align-items: center;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ffffff;
      justify-content: center;
      color: #ffffff;

      span {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 0px;
      }
    }

    .login_l {
      /*width: 65px;*/

      height: 32px;
      line-height: 32px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ffffff;

      color: #397ef5;
    }
  }
}
</style>
